<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import FieldHeading from './field-heading.svelte'
    import { GLOGAU_SCALE_OPTIONS, findGlogauOption, type GlogauScaleValue } from '../../types/glogau-scale'

    export let label: string
    export let data: Record<string, any>
    export let value: GlogauScaleValue = null
    export let required = false
    export let readOnly = false

    function select(key: string) {
        if (readOnly) return
        value = key
    }

    $: selectedOption = findGlogauOption(value)
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="glogau-scale">
        {#each GLOGAU_SCALE_OPTIONS as option (option.key)}
            <button
                type="button"
                class="glogau-row"
                class:selected={value === option.key}
                disabled={readOnly}
                on:click={() => select(option.key)}
            >
                <span class="glogau-type">
                    {option.label}
                    <span class="glogau-tooltip-icon" title={option.tooltip}>
                        <Fa icon={faCircleQuestion} />
                    </span>
                </span>
                <span class="glogau-age">{option.ageRange}</span>
                <span class="glogau-desc">{option.description}</span>
            </button>
        {/each}
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .glogau-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .glogau-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        padding: 10px 14px;
        border: none;
        border-radius: 8px;
        background: #f8f9fa;
        font: inherit;
        text-align: left;
        cursor: pointer;
    }
    .glogau-row:disabled {
        cursor: not-allowed;
    }
    .glogau-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .glogau-type {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .glogau-row.selected .glogau-type {
        color: #1f2937;
    }
    .glogau-age {
        flex: 1;
        min-width: 0;
        text-align: center;
        font-size: 0.85rem;
        color: #495057;
    }
    .glogau-desc {
        flex: 1;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .glogau-row.selected .glogau-age,
    .glogau-row.selected .glogau-desc {
        color: #1f2937;
    }
    .glogau-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
        cursor: help;
    }
    .glogau-row.selected .glogau-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
